import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { layoutColorKeys } from './colors'

const ToggleListButtonColors = layoutColorKeys.Layout.ToggleListButton

export const enum ToggleListButtonVariants {
  'Default' = 'default',
  'Disabled' = 'disabled',
}

const ToggleListButtonParts = ['container', 'iconButton', 'icon'] as const

const helpers = createMultiStyleConfigHelpers(ToggleListButtonParts)

export const ToggleListButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      width: 'full',
      alignItems: 'center',
      justifyContent: 'center',
      borderBottom: '2px solid',
      borderColor: ToggleListButtonColors.IconButton.Border,
    },
    iconButton: {
      display: 'flex',
      minWidth: '2rem',
      width: '4rem',
      height: '4.5rem',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: ToggleListButtonColors.IconButton.Background,
    },
    icon: {
      boxSize: '1.25rem',
    },
  },
  variants: {
    [ToggleListButtonVariants.Default]: {
      iconButton: {
        _hover: {
          backgroundColor: ToggleListButtonColors.IconButton.Hover.Background,
        },
        _active: {
          backgroundColor: ToggleListButtonColors.IconButton.Active.Background,
        },
      },
    },
    [ToggleListButtonVariants.Disabled]: {
      iconButton: {
        '& > svg': {
          color: ToggleListButtonColors.Icon.Disabled.Color,
        },
      },
    },
  },
})

export const useToggleListButtonStyles = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof ToggleListButtonParts>(
    getName({ ToggleListButtonStyle }),
    props,
  )
}
